import { getApi, deleteApi } from "../../services/api";

export const getStoriesList = () => getApi(`/stories-admin`, "/api/v1/feed");

export const deleteStory = (reelId) =>
  deleteApi(`/stories-admin/${reelId}`, "/api/v1/feed");

export const getStoryDetails = (reelId) =>
  getApi(`/stories-admin/${reelId}`, "/api/v1/feed");
